import { Injectable } from '@angular/core';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  stripe!: Stripe | null;
  elements!: StripeElements | null;
  paymentElement: any;
  cardElement!: StripeCardElement | null;

  async initializeStripe(publishableKey: string) {
    this.stripe = await loadStripe(publishableKey);
  }

  async mountPaymentElement(clientSecret: string, containerId: string) {
    if (!this.stripe) {
      console.error('Stripe is not initialized');
      return;
    }

    this.elements = this.stripe.elements({ clientSecret });
    const paymentElement = this.elements.create('payment');
    paymentElement.mount(`#${containerId}`);

    this.paymentElement = paymentElement;
  }

  confirmPayment(returnUrl: string) {
    if (!this.stripe || !this.elements) {
      console.error('Stripe or Elements are not initialized');
      return;
    }

    return this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        return_url: returnUrl
      }
    });
  }


}
